<template>
  <div class="left-nav-upper" :class="{'justify-center': isEnableAddinPowerpoint }">
    <div v-if="!canEditPresentation" class="overlay-disable-top-side-left"></div>

    <NewSlideButton class="left-nav-upper-button" @addNewSlide="addNewSlide" />

    <div v-if="!isEnableAddinPowerpoint" class="button-divider">
      <div class="button-divider-line"></div>
    </div>

    <LegacyImportButton
      v-if="isLegacyImportButtonVisible"
      class="left-nav-upper-button"
      @importPpt="importPpt"
      :isImportingSlides="isImportingSlides"
      :isImportButtonDisabled="isImportButtonDisabled"
    />

    <ImportButtonV3
      v-if="isAIChatbotImportButtonVisible"
      class="left-nav-upper-button"
      :isSelectMode="isSelectMode"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import utils from '@/util'
import configs from '@/config'
import EventBus from '@/eventBus'
import { EVENT_CATEGORIES_BY_ROUTE_NAME } from '@/constant/routes'
import ImportButtonV3 from '@/components-v2/ai-chatbot/ImportButtonV3.vue'
import NewSlideButton from '@/components-v2/presentation-editor/side-left/NewSlideButton.vue'
import LegacyImportButton from '@/components-v2/presentation-editor/side-left/LegacyImportButton.vue'

export default {
  components: {
    ImportButtonV3,
    NewSlideButton,
    LegacyImportButton,
  },

  props: {
    isSelectMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('aiChatbotImportPptxPdf', ['canUseAIChatbotImportPptxPdf', 'canUseAIChatbotImportUIUX']),
    ...mapGetters('blankPresentation', ['canUseOnBoardingBlankPresentation']),
    ...mapState({
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      isImportingSlides: (state) => state.importStatus === 2 || state.importStatus === 3,
      canEditPresentation: (state) => state.canEditPresentation,
      presentation: (state) => state.presentation,
    }),

    isImportButtonDisabled() {
      return this.isSelectMode
    },

    isLegacyImportButtonVisible() {
      return !this.isEnableAddinPowerpoint && !(this.canUseAIChatbotImportPptxPdf || this.canUseAIChatbotImportUIUX)
    },

    isAIChatbotImportButtonVisible() {
      return !this.isEnableAddinPowerpoint && (this.canUseAIChatbotImportPptxPdf || this.canUseAIChatbotImportUIUX)
    },
  },

  mounted() {
    EventBus.$on('openImport', () => {
      this.importPpt()
    })
  },

  destroyed() {
    EventBus.$off('openImport')
  },

  methods: {
    ...mapActions(['patchPresentationAction', 'setSlideSearchPopupVisibilityAction']),
    addNewSlide() {
      if (this.presentation.slides?.length === 0) {
        this.setSlideSearchPopupVisibilityAction(true)
      } else {
        this.$emit('addNewSlide')
      }
    },

    _isReachLimitSlides() {
      if (this.presentation.slides.length >= configs.MAX_NUMBER_OF_SLIDE) {
        EventBus.$emit('openModalLimitSlides')
        this.$store.state.openImportModal = false
        return true
      }
      return false
    },

    importPpt() {
      this.$store.state.openImportModal = true
      if (this._isReachLimitSlides()) return
      utils.mixpanelTracking(
        EVENT_CATEGORIES_BY_ROUTE_NAME[this.$route.name],
        'Import > Open modal',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.left-nav-upper {
  @apply relative flex w-full;
  @apply items-center justify-center;
  @apply px-5 py-4;
}

.left-nav-upper-button {
  transition: all 0.1s ease-in-out;
}

.button-divider {
  @apply px-2;
  .button-divider-line {
    width: 1px;
    height: 24px;
    background-color: var(--color-gray-35, #EBEBEB);
  }
}

.overlay-disable-top-side-left {
  @apply bg-base-0 opacity-50 absolute top-0 left-0 w-full h-full;
  z-index: 9;
}
</style>
